import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoaderIcon, toast } from "react-hot-toast";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { getVendorName } from "../../../utils/getVendorName";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { useAddQrMappingToDistributorMutation } from "../../../features/tenant/QrMapping/QrMappingApi";
import { downloadCSV } from "../../../utils/downloadCSV";
import SelectComponentWithSearch from "../../../components/Tenant/SelectComponentWIthSearch/SelectComponentWithSearch";
import { useFetchProductsMutation } from "../../../features/tenant/products/productsApi";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import { useFetchUserByUserTypeMutation } from "../../../features/tenant/appUsers/appUsersApi";
import { getLoginUserData } from "../../../utils/getLoginUserData";

const QrMappingToUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { zone_id: zoneId, zone_name: zoneName } = getLoginUserData();
  const [selectedUserType, setSelectedUserType] = useState({
    name: "Select User Type",
    id: -1,
  });
  const [searchQuery, setSearchQuery] = useState(null);
  const [allUserTypes, setAllUserTypess] = useState(
    JSON.parse(sessionStorage.getItem("appUserType"))
  );

  const searchHandler = () => {
    console.log("clicked");
    if (selectedUserType.id == -1) {
      toast.error("Select user type", { id: "invalid-user-type" });
    }
    if (searchQuery && searchQuery.length != 10) {
      toast.error("mobile Number is not valid", { id: "invalidMobile" });
      return;
    }
    if (searchQuery && searchQuery.length > 3) {
      if (
        selectedUserType &&
        selectedUserType.id != -1 &&
        searchQuery &&
        searchQuery.length > 3
      ) {
        console.log("selectedUserType", selectedUserType);
        fetchAppUserByUserTypeFunction(
          selectedUserType.user_type_id,
          1,
          0,
          searchQuery
        );
      }
    }
  };

  const initialRequest = {
    user_type_id: -1,
    limit: 10,
    offset: 0,
    mobile: "",
    startDate: "",
    endDate: "",
  };
  const [request, setRequest] = useState(initialRequest);
  const [user, setUser] = useState(null);
  const [
    fetchAppUserByUserType,
    { data: appUsersData, error: appUsersError, isLoading: appUsersIsLoading },
  ] = useFetchUserByUserTypeMutation();

  const fetchAppUserByUserTypeFunction = (
    userTypeId,
    limit,
    offset,
    searchQuery
  ) => {
    request["limit"] = limit;
    request["offset"] = offset;
    request["user_type_id"] = userTypeId;

    request["mobile"] = searchQuery;

    fetchAppUserByUserType({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
      zoneId: zoneId,
    });
  };

  useEffect(() => {
    if (appUsersData && appUsersData.body) {
      console.log("appUsersData", appUsersData);
      if (
        appUsersData?.body?.appUsersList &&
        appUsersData.body.appUsersList.length > 0
      ) {
        setUser(appUsersData.body.appUsersList[0]);
      } else {
        setUser(-1);
      }
    }
  }, [appUsersData]);
  const [array, setArray] = useState([]);
  const [startBatchRunningCode, setStartBatchRunningCode] = useState();
  const [endBatchRunningCode, setEndBatchRunningCode] = useState();
  const [
    addQrMapping,
    {
      data: addQrMappingData,
      error: addQrMappingError,
      isLoading: addQrMappingIsLoading,
    },
  ] = useAddQrMappingToDistributorMutation();

  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({
    id: -1,
    name: "",
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (!startBatchRunningCode || !endBatchRunningCode) {
      toast.error("Please fill all the fields");
      return;
    }

    if (!user) {
      toast.error("Please Select a user");
      return;
    }

    console.log(startBatchRunningCode >= endBatchRunningCode);
    if (startBatchRunningCode >= endBatchRunningCode) {
      toast.error(
        "Start batch running code must be smaller than end batch running code"
      );
      return;
    }
    toast.loading("Processing your data...");
    console.log(user);
    addQrMapping({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        startBatchRunningCode,
        endBatchRunningCode,
        out_id: user.id,
        userType: user.user_type,
      },
      apikey: JSON.parse(sessionStorage.getItem("companyProfile")).api_key,
    });
  };

  useEffect(() => {
    if (addQrMappingData) {
      toast.dismiss();
      toast.success("Saved Successfully", {
        id: "addQrMappingData",
      });
      console.log("addQrMappingData", addQrMappingData);
      setTimeout(() => {
        navigate(`/genefied/${getVendorName()}/printQr`);
      }, 400);
    }

    if (addQrMappingError) {
      toast.dismiss();
      toast.error("Something went wrong");
      console.log("addQrMappingError", addQrMappingError);
    }
  }, [addQrMappingData, addQrMappingError]);

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
          Bulk Qr mapping to User
            <LinksComponent />
          </div>

          <div className="mx-9 mt-10">
            <div className="flex space-x-3"></div>
            <form className="bg-white m-auto border-opacity-40 rounded-lg flex w-full p-4 px-5 justify-center">
              <div className=" flex flex-col justify-center align-middle w-full">
                <div className="">
                  <div className="text-center ">
                    <div className="w-full  justify-center items-center space-x-4">
                      <div className="w-full flex justify-start space-x-4 mb-4">
                        <div className=" bottom-2 w-1/3">
                          <SelectComponentWithSearch
                            title={"Select User Type"}
                            selected={selectedUserType}
                            setSelected={setSelectedUserType}
                            dataArr={allUserTypes ? allUserTypes : []}
                            placeholder={"Select User Type"}
                          />
                        </div>

                        <div className=" bottom-2 w-1/2">
                          <>
                            <div className="w-full relative">
                              <label
                                htmlFor="Enter Mobile"
                                className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-0"
                              >
                                Enter Mobile
                              </label>
                              <input
                                type="text"
                                id="Enter Mobile"
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-12" // Add padding-right for the button
                                placeholder="Enter Mobile"
                                required={true}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                              />
                              <button
                                type="button"
                                className="absolute -mt-5 right-1 transform -translate-y-1/2 bg-blue-500 hover:bg-blue-600 text-white p-1.5 rounded-md"
                                onClick={() => searchHandler()}
                              >
                                Search
                              </button>
                            </div>
                          </>
                        </div>

                        <div className="mt-6 w-1/4 bg-gray-50 hover:bg-gray-200 rounded-lg flex px-2">
                          {appUsersIsLoading && (
                            <LoaderIcon className="w-5 h-5 mt-2.5" />
                          )}
                          {user ? (
                            user != -1 ? (
                              // user.map((item) => (
                              <div className="w-full flex items-center space-x-2 ">
                                <div className="rounded-full w-6 h-6 border border-gray-300 flex items-center justify-center">
                                  {true && (
                                    <div className="bg-blue-500 w-3 h-3 rounded-full"></div>
                                  )}
                                </div>
                                <span className="text-gray-800 flex justify-center items-center font-medium capitalize">
                                  {user.name}
                                </span>
                              </div>
                            ) : (
                              // ))
                              <h3 className="text-sm flex max-w-xs justify-start items-center font-semibold text-gray-500 mb-2 text-center">
                                <svg
                                  class="h-8 w-8 m-auto text-gray-300 text-center"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  {" "}
                                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />{" "}
                                  <circle cx="12" cy="7" r="4" />
                                </svg>
                                User Not Found
                              </h3>
                            )
                          ) : (
                            <> </>
                          )}
                        </div>
                      </div>

                      <div className="w-full flex  justify-center items-center space-x-4">
                      <div className="mb-6 bottom-2 w-1/4">
                        <InputComponent
                          name={"Starting Batch Running Code"}
                          type={"text"}
                          value={startBatchRunningCode}
                          setValue={setStartBatchRunningCode}
                          required={true}
                        />
                      </div>
                      <div className="mb-6 bottom-2 w-1/4">
                        <InputComponent
                          name={"End Batch Running Code"}
                          type={"text"}
                          value={endBatchRunningCode}
                          setValue={setEndBatchRunningCode}
                          required={true}
                        />
                      </div>
                      <div className="flex justify-end mt-2">
                        <button
                          onClick={(e) => handleOnSubmit(e)}
                          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                        >
                          Submit
                        </button>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default QrMappingToUser;
